const genRadius = radiusBase => {
  let radiusXL = radiusBase; // Dui
  let radiusLG = radiusBase;
  let radiusSM = radiusBase;
  let radiusXS = radiusBase;
  let radiusOuter = radiusBase;
  // radiusXL
  // Dui start
  if (radiusBase < 6 && radiusBase >= 5) {
    radiusXL = radiusBase + 1;
  } else if (radiusBase < 16 && radiusBase >= 6) {
    radiusXL = radiusBase + 4;
  } else if (radiusBase >= 16) {
    radiusXL = 16;
  }
  // Dui end
  // radiusLG
  if (radiusBase < 6 && radiusBase >= 5) {
    radiusLG = radiusBase + 1;
  } else if (radiusBase < 16 && radiusBase >= 6) {
    radiusLG = radiusBase + 2;
  } else if (radiusBase >= 16) {
    radiusLG = 16;
  }
  // radiusSM
  // Dui start
  if (radiusBase < 7 && radiusBase >= 5) {
    radiusSM = 6;
  } else if (radiusBase < 8 && radiusBase >= 7) {
    radiusSM = 7;
  } else if (radiusBase < 14 && radiusBase >= 8) {
    radiusSM = 8;
  } else if (radiusBase < 16 && radiusBase >= 14) {
    radiusSM = 9;
  } else if (radiusBase >= 16) {
    radiusSM = 10;
  }
  // Dui end
  // radiusXS
  if (radiusBase < 6 && radiusBase >= 2) {
    radiusXS = 1;
  } else if (radiusBase >= 6) {
    radiusXS = 2;
  }
  // radiusOuter
  if (radiusBase > 4 && radiusBase < 8) {
    radiusOuter = 4;
  } else if (radiusBase >= 8) {
    radiusOuter = 6;
  }
  return {
    borderRadius: radiusBase,
    borderRadiusXS: radiusXS,
    borderRadiusSM: radiusSM,
    borderRadiusLG: radiusLG,
    borderRadiusXL: radiusXL,
    // Dui
    borderRadiusOuter: radiusOuter
  };
};
export default genRadius;